import { InputWithSign } from '@/modules/common/components/input-with-sign';
import styles from './index.module.sass';
import { MAX_TARGET_MOISTURE } from '@@/mixing/constants/calculator.constants';
import { Checkbox, notification } from 'antd';
import { ITargetMoistureData } from '../../hooks';
import Decimal from 'decimal.js';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';

export const ExpertModeControls = ({
  targetMoistureData,
  setTargetMoisture,
  setEnableMoistenUnmixed,
  style,
}: IArgs) => {
  return (
    <>
      <InputWithSign
        max={MAX_TARGET_MOISTURE}
        value={targetMoistureData.targetMoisture}
        allowZero={true}
        onChange={(e) => {
          if (e.target.value === '') return setTargetMoisture('0');
          const val = e.target.value.replace(/[^0-9.]/g, '');
          setTargetMoisture(
            parseFloat(val) > MAX_TARGET_MOISTURE
              ? MAX_TARGET_MOISTURE.toString()
              : val,
          );
        }}
        onWheel={(e: any) => {
          const val = new Decimal(targetMoistureData.targetMoisture);

          if (e.ctrlKey) {
            e.deltaY < 0
              ? setTargetMoisture(
                  val.plus(0.1).toNumber() < MAX_TARGET_MOISTURE
                    ? val.plus(0.1).toNumber().toString()
                    : MAX_TARGET_MOISTURE.toString(),
                )
              : parseFloat(targetMoistureData.targetMoisture) > 0
              ? setTargetMoisture(String(val.minus(0.1).toNumber()))
              : setTargetMoisture('0');
          } else {
            e.deltaY < 0
              ? setTargetMoisture(
                  val.plus(1).toNumber() < MAX_TARGET_MOISTURE
                    ? val.plus(1).toNumber().toString()
                    : MAX_TARGET_MOISTURE.toString(),
                )
              : parseFloat(targetMoistureData.targetMoisture) > 0 &&
                setTargetMoisture(String(val.minus(1).toNumber()));
          }
        }}
        postfix="%"
        onClick={handleClick}
        className={styles.targetMoisture}
        inputClassName={styles.targetMoistureInput}
        placeholder="целевая влажность"
      />
      <div className={styles.koef}>
        <div
          className={styles.checkBox}
          onClick={() => {
            if (!targetMoistureData.targetMoisture) {
              return notification.warning({
                message: 'Не указана целевая влажность!',
              });
            }
            setEnableMoistenUnmixed(!targetMoistureData.enableMoistenUnmixed);
          }}
        >
          <Checkbox
            className={styles.inp}
            checked={targetMoistureData.enableMoistenUnmixed}
          />
          <span className={styles.label}>Увлажнять ДО миксования</span>
        </div>
        <div>
          <span className={styles.koefLabel}>коэффицент усушки: </span>
          <span
            className={styles.koefValue}
            style={{
              color: +targetMoistureData.shrincageCoeff < 0 ? '#E73A42' : '#007E3C',
            }}
          >
            {targetMoistureData.shrincageCoeff}
          </span>
        </div>
      </div>
    </>
  );
};

interface IArgs {
  targetMoistureData: ITargetMoistureData;
  setTargetMoisture: (val: string) => void;
  setEnableMoistenUnmixed: (val: boolean) => void;
  style?: StyleSheet;
}
